import { render, staticRenderFns } from "./Treinamentos.vue?vue&type=template&id=6efdb025&"
import script from "./Treinamentos.vue?vue&type=script&lang=js&"
export * from "./Treinamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports